import { render, staticRenderFns } from "./detalleProducto.vue?vue&type=template&id=42881744&"
import script from "./detalleProducto.vue?vue&type=script&lang=js&"
export * from "./detalleProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports